import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

interface DoughnutCardProps {
    title: string;
    description?: string;
    total?: number;
    data: DoughnutData[];
    missingLabel?: string;
    missingColour?: string;
}

interface DoughnutCardState {
    percentage: number;
    doughnutData: any;
}

export interface DoughnutData {
    label: string;
    value: number;
    colour: string;
}

export default class DoughnutCard extends Component<DoughnutCardProps, DoughnutCardState>
{
    constructor(props: Readonly<DoughnutCardProps>) {
        super(props);

        this.state = {
            percentage: 0,
            doughnutData: []
        };
    }

    public componentDidMount() {
        this.calculateDoughnutData()
    }
    
    private calculateDoughnutData(): void {

        var labels = this.props.data.map(x => x.label);
        var data = this.props.data.map(x => x.value);
        var colours = this.props.data.map(x => x.colour);

        if (this.props.total !== undefined && this.props.total! > 0) {
            labels.push(this.props.missingLabel ?? "unknown");          
            data.push(this.props.total! - this.countData());

            if (this.props.missingColour !== undefined) {
                colours.push(this.props.missingColour!);
            }
        }

        var doughnutData = {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: colours
            }]
        }              

        this.setState({ doughnutData: doughnutData })
    }

    private countData(): number {
        return this.props.data.reduce((sum, current) => sum + current.value, 0);
}

    private calculatePercentage(): string | undefined {

        if (this.props.total === undefined || this.props.total <= 0) {
            return undefined;
        }

        var count = this.countData();
        return ((count / this.props.total!) * 100).toFixed(0);
    }
    
    public render() {

        var percentage = this.calculatePercentage();

        return (
            <div className="doughnut-card flex-item--flex-1 flex-column flex--align-items-center">
                <div className="doughnut-card__title">  
                      {this.props.title}            
               </div>
                <div className="doughnut-holder--small">
                    <Doughnut data={this.state.doughnutData} height={1} width={1} key={this.props.title} />
                </div>
                {
                    percentage !== undefined ? <div className="doughnut-card__percentage"> {percentage}%</div> : undefined
                }
                {
                    this.props.description ? <div className="doughnut-card__description"> {this.props.description} </div> : undefined
                }
            </div>
        )
    }
}